export const validationContentAnimation = `
  animation: validationContent 2s forwards;
  @keyframes validationContent {
    0% {
      opacity: 0;
    }
    
    70% {
      opacity: 0;
    }
    80% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }

  }
`;

export const backgroundAnimation = `
  animation: backgroundAnimation 2s forwards;

  @keyframes backgroundAnimation {
    0% {
      width: 0%;
      left: 0px;
    }
    30% {
      width: 100%;
      left: 0px;
    }
    60% {
      width: 40px;
      height: 40px;
      left: calc(100% - 40px);
      transform: scale(1);
    }
    69% {
      width: 40px;
      height: 40px;
      transform: scale(0);
      opacity: 1;
    }
    70% {
      width: 40px;
      height: 40px;
      opacity: 0;
      transform: scale(0);
    }
    100% {
      opacity: 0;
      left: calc(100% - 40px);
      transform: scale(0);
    }
  }
`;
